<template>
	<q-card-section class="bg-primary q-px-md q-py-md q-mb-md">
		<div class="row">
			<h5 class="text-white q-my-none col">{{ title }}</h5>
			<div class="col col-shrink">
				<q-btn v-if="dialogCloseButton" @click="$emit('close')" class="dialog-close" icon="close" text-color="white" unelevated/>
			</div>
		</div>
	</q-card-section>
</template>

<script>
	export default {
		name: "DialogHeader",
		props: {
			dialogTitle: String,
			rawTitle: {
				type: Boolean,
				default: false
			},
			dialogCloseButton: {
				type: Boolean,
				default: true
			},
			dialogPersistent: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			title() {
				if(this.rawTitle) {
					return this.dialogTitle;
				}

				return this.$t(this.dialogTitle);
			}
		}
	}
</script>

<style lang="scss" scoped>
	h5 {
		line-height: 1.5;
	}
</style>